<template>
    <div>
        <id-verification-internal />
    </div>
</template>


<script>
import IdVerificationInternal from "@/components/idVerification/IdVerificationInternal";

export default {
    components: {
        IdVerificationInternal,
    },
};
</script>